'use client'

import {PhoneInputStyled, PhoneInputWrapper} from "@/components/UI/Form/Inputs/PhoneInput/PhoneInput.styled";
import Label from "@/components/UI/Form/Label/Label";
import {Field} from "formik";
import {useState} from "react";
import ErrorMessage from "@/components/UI/Form/ErrorMessage/ErrorMessage";

const PhoneInput = ({label, name, error, ...props}) => {
    const [isFirstOnChangeEvent, setIsFirstOnChangeEvent] = useState(true)

    return (
        <PhoneInputWrapper>
            <Field name={name ?? label}>
                {
                    ({field, form, meta}) => <>
                        {label && <Label>{label}</Label>}
                        <PhoneInputStyled
                            defaultCountry={'am'}
                            {...field}
                            {...props}
                            value={field.value ?? ''}
                            onChange={(value) => {
                                if (isFirstOnChangeEvent) {
                                    setIsFirstOnChangeEvent(false)
                                    return;
                                }

                                if (value === '') {
                                    return form.setFieldValue(field.name, undefined);
                                }

                                form.setFieldValue(field.name, value);
                            }}
                        />
                        <ErrorMessage meta={meta} error={error} />
                    </>
                }
            </Field>
        </PhoneInputWrapper>
    );
};

export default PhoneInput;